<script setup>
import {RouterView} from 'vue-router'
import TheHeader from "@/components/Header.vue";
import TheFooter from "@/components/Footer.vue";
</script>


<template>
  <div id="app">
    <TheHeader/>
    <main id="main-content" class="flex-grow-1" tabindex="-1">
      <RouterView/>
    </main>
    <TheFooter/>
  </div>
</template>

<style lang="scss">
  @import "./scss/variables";
  @import "./scss/mixins";

  #app {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  h1 {
    color: $firstcolor;
    font-family: $titlefont;
    font-weight: 900 !important;
  }

  hr {
    background-color: $firstcolor;
    margin-bottom: 2rem;
  }

  #modal_erreur {
    .modal-title {
      color: $danger;
      font-family: $titlefont;
      font-size: 30px;
    }

    .description {
      color: $firstcolor;
      text-align: center !important;
      margin: 1rem auto 1rem auto !important;
      font-family: $textfont;
      font-size: 20px;
    }
    .modal-footer {
      button {
        background-color: $secondcolor;
        color: #212529;
        border-radius: 50px;
        border-color: transparent;
      }
      button:hover {
        background-color: $roll-over;
        color: white;
      }
    }
  }
</style>
